// @ts-nocheck
/* eslint-disable */
import { store } from "~/state/store";
import * as Provider from "~/util/providers/photo";
import Scene from "~/scene";
import Canonical from "~/canonical";
import Notifications from "~/util/notifications";
import { setCoordinates } from "~/state/map/state";

/* Pouzdro na lazyloadovanou galerii */
/* Lazyloadovana galerie - vstupni bod */
export default class PhotoGallery {
	_active: boolean;

	constructor() {
		this._active = false;
		this._options = {};
		this._gallery = null;
		this._source = "";
		this._id = "";
		this._keyboardMode = 0;
		this._galleryRun = false;
		this._historyReplace = false;
		this._loadPromise = null;
		this._onClose = (type, data) => {
			if (!this.isActive()) { return this; }
			let source = this._source;
			let id = this._id;

			if ((type !== "photo-delete" || (type === "photo-delete" && !data)) && type != "extern-close") {
				Mapy.getComponent("logger").log("gallery_close", this.logData);
				this._galleryRun = false;
			}

			if (type !== "photo-delete") {
				this.deactivate();
			}

			if (type === "photo-delete" && data) {
				Provider.clear(data.source, data.id);
				Provider.clear(source, id);
			}
			else if (type != "extern-close") {
				const event = new CustomEvent("photo-gallery-close");
				Scene.getContainer().dispatchEvent(event);
			}
		};
	}

	destroy() {
	}

	get node() {
		if (this._gallery) {
			return this._gallery.node;
		}

		return null;
	}

	activate() {
		if (this.isActive()) { return this; }
		let historyReplace = false;

		Mapy.getComponent("loader").start(true);

		if (!this._loadPromise) {
			this._loadPromise = Promise.all([import(
				/* webpackChunkName: "photoGallery" */
				'~/photo/gallery/index.ts'
			), Mapy.Util.loadScript(`/js/pig.min.js`)]);
		}

		const imports = [this._loadPromise];

		if (this._options.source === "author" && this._options.id && typeof this._options.id === "string" && this._options.id.match(/^\d+$/)) {
			imports.push(Provider.getAuthor(this._options.id).then(d => {
				this._options.id = d.author.userPublicId;
				this._id = d.author.userPublicId;
				historyReplace = true;
			}, () => {}));
		}

		Promise.all(imports).then(async module => {
			module[0][0].initModule({ store, Provider, Canonical, Notifications });
			this._gallery = new module[0][0].default(Object.assign({
				onClose: (type, data) => {
					if (this._source === "author" && Scene) {
						let cz = this._gallery.mapCenterZoom;

						if (cz) {
							const [longitude, latitude] = cz.coords;

							store.dispatch(setCoordinates({
								longitude,
								latitude,
								zoom: cz.zoom,
								animate: false,
							}));
						}
					}

					this._onClose(type, data);

					if (!Mapy.getComponent("history").isFromHistory()) {
						Mapy.getComponent("history").save();
					}
				},
			}, this._options));

			await this._gallery.open()
			Mapy.getComponent("loader").end();
			historyReplace && Mapy.getComponent("history").save(true);

			// vezmeme mape klavesnici, abychom mohli ovladat sipkama
			let keyboard = Scene.getKeyboardControl();

			if (keyboard) {
				this._keyboardMode = keyboard.getMode();
				keyboard.configure(0);
			}

			if (!this._galleryRun) {
				// timeout nez dojde k nacteni informaci
				window.setTimeout(() => {
					Mapy.getComponent("logger").log("gallery_open", this.logData);
				}, 800);

				this._galleryRun = true;
			}
		}, () => {});

		this._active = true;

		return this;
	}

	deactivate() {
		if (!this.isActive()) { return this; }

		if (this._gallery) {
			this._gallery.close();
			this._gallery.destroy();
			this._gallery = null;
		}

		this._source = "";
		this._id = "";

		this._active = false;

		// vezmeme mape klavesnici, abychom mohli ovladat sipkama
		let keyboard = Scene.getKeyboardControl();

		if (keyboard) {
			keyboard.configure(this._keyboardMode);
		}

		document.getElementById("mapycz").style.display = "";
		requestAnimationFrame(() => {
			Scene.syncPort();
		});

		return this;
	}

	isActive() {
		return this._active;
	}

	setState(state) {
		if (Mapy.getComponent("history").isFromHistory() && this._active) {
			this.close();
		}

		const poiGalleryFromState = "gallery" in state && state.source && state.source !== "author";
		// galerie v detailu
		if (poiGalleryFromState || state.source === "author") {
			this._source = state.source;
			this._id = poiGalleryFromState && state.source !== "coor"? parseFloat(state.id) : state.id;

			let data = {
				source: this._source,
				id: this._id,
				zoom: "z" in state ? parseInt(state.z) : 0,
			};

			if (state.sourcep && state.idp) {
				data.photo = {
					source: state.sourcep,
					id: parseFloat(state.idp),
					forceHistorySave: state.forceHistorySave,
				};
			}

			if (state.gsort) {
				data.sort = state.gsort;
			}

			if (state.coords) {
				data.coords = state.coords;

				if (this._options) {
					this._options.coords = state.coords;
				}
			}

			if (this._options.source !== this._source || this._options.id !== this._id) {
				this._options = data;
			}
			else if (data.photo) {
				this._options.photo = data.photo;
			}
			else {
				delete this._options.photo;
			}

			this.activate();
		}
	}

	getState() {
		let state = {};

		if (this._active) {
			if (this._source === "author") {
				state = { source: this._source, id: this._id };
			}
			else {
				state = { gallery: 1 };
			}

			if (this._gallery) {
				let sort = this._gallery.sort;

				if (sort != "") {
					state.gsort = sort;
				}
			}
		}

		return state;
	}

	setData(data) {
		this._options = data;

		if (data.source) {
			this._source = data.source;
		}

		if (data.id) {
			this._id = data.id;
		}

		this.reload();
	}

	getData() {
		return { source: this._source, id: this._id };
	}

	reload() {
		// pouze obohaceni dat, nenacte novou galerii
		if (this._active && this._gallery) {
			this._gallery.reload(this._options);
		}
	}

	close(type = "extern-close", data) {
		this._onClose(type, data);
	}

	loadNextPage() {
		if (this._gallery) {
			return this._gallery.loadNextPage();
		}
		else {
			return Promise.resolve(null);
		}
	}

	countPhotos() {
		return 0;
	}

	get logData() {
		if (this._gallery) {
			return this._gallery.logData;
		}

		return null;
	}

	mapCenterZoom(coords) {
		this._gallery && this._gallery._mapCenterZoom(coords);
	}
}
